export default __webpack_public_path__ + "static/media/hasancover.7345da58.jpg";